"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../../node");
class TwingProfilerNodeLeaveProfile extends node_1.TwingNode {
    constructor(varName) {
        super(new Map(), new Map([['var_name', varName]]));
        this.type = node_1.TwingNodeType.PROFILER_LEAVE_PROFILE;
    }
    compile(compiler) {
        compiler
            .write("\n")
            .write(`${this.getAttribute('var_name')}.leave(${this.getAttribute('var_name') + 'Prof'});\n\n`);
    }
}
exports.TwingProfilerNodeLeaveProfile = TwingProfilerNodeLeaveProfile;
